import { render, staticRenderFns } from "./IcoUGC.vue?vue&type=template&id=2876a063"
import script from "./IcoUGC.vue?vue&type=script&lang=js"
export * from "./IcoUGC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports